import { createStore, applyMiddleware, Middleware, Store } from "redux";
import { History } from "history";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { createLogger } from "redux-logger";
import { default as thunk } from "redux-thunk";
import { createMessageReceiverMiddleware } from "redux-postmessage-middleware";

import { rootReducer } from "@app/reducers/index";
import { api } from "@api/middleware/api";
import { GlobalState } from "@app/models/state";
import * as actions from "@app/actions";
import { OLD_WATA_URL } from "@app/constants/urls";

// Log everything but form actions.
const logger: Middleware = createLogger({
    predicate: (_getState: () => any, action: actions.Action) =>
        !action.type.startsWith("@@redux-form/") && action.type !== "Api/REQUEST_PROGRESS",
});

const postMessage: Middleware = createMessageReceiverMiddleware({
  allowedURLs: [OLD_WATA_URL],
});

export function configureStore(history: History, initialState: GlobalState): Store<GlobalState> {
    const router: Middleware = routerMiddleware(history);

    return createStore<GlobalState>(
        connectRouter(history)(rootReducer),
        initialState,
        applyMiddleware(thunk, router, api, logger, postMessage),
    );
    // return createStoreWithMiddleware(rootReducer, initialState);
}
